function prefersReducedMotion(): boolean {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

export default function imageStackBanner(root: HTMLElement): void {
  const stack = root.querySelector<HTMLElement>('[data-image-stack]');

  if (!stack) {
    return;
  }

  const open = (): void => {
    root.classList.add('is-open');
  };

  if (prefersReducedMotion()) {
    open();
    return;
  }

  if (!('IntersectionObserver' in window)) {
    open();
    return;
  }

  const observer = new IntersectionObserver(
    entries => {
      const entry = entries[0];

      if (!entry?.isIntersecting) {
        return;
      }

      open();
      observer.disconnect();
    },
    {
      threshold: 0.35,
      rootMargin: '0px 0px -10% 0px'
    }
  );

  observer.observe(root);
}
